import { Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { HoverTip } from '@/components/ui/HoverTip';
import { useSettingsHeader } from '@/providers/settings/SettingsContext';

export const SettingsHeader = () => {
  const { canClose, handleClose, handleReplayOnboarding } = useSettingsHeader();

  return (
    <header className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-xl lg:text-2xl font-semibold tracking-tight">
          Settings
        </h1>
        <p className="mt-1 text-sm lg:text-base text-foreground-muted">
          Configure scrapers, scoring, and integrations.
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button
          onClick={handleReplayOnboarding}
          size="sm"
          type="button"
          variant="outline"
        >
          <Sparkles className="size-3.5" /> Replay onboarding
        </Button>
        {canClose && (
          <HoverTip align="end" text="Close settings  Esc">
            <button
              aria-label="Close settings"
              className="inline-flex size-7 items-center justify-center rounded-md border border-border bg-surface text-foreground-muted transition-colors hover:bg-border/40 hover:text-foreground"
              onClick={handleClose}
              type="button"
            >
              <X className="size-3.5" />
            </button>
          </HoverTip>
        )}
      </div>
    </header>
  );
};
